<template>
    <div>
        <h1>Editar usuario</h1>
        <form-usuario @registrado="onRegistrado" :usuario="usuario"></form-usuario>
        <v-progress-linear
        :active="cargando"
        :indeterminate="cargando"
        absolute
        top
        color="deep-purple accent-4"
        ></v-progress-linear>
        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        top
        >
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>
<script>
import ApiService from '../../Servicios/ApiService'
import FormUsuario from './FormUsuario.vue'

export default {
    name: "EditarUsuario",
    components: { FormUsuario },

    data: () => ({
        cargando: false,
        usuario: {},
        mostrarMensaje: false,
        mensaje: { texto: '', color: '' }
    }),

    async mounted () {
        this.cargando = true
        try {
            this.usuario = await ApiService.get(`api/panel/usuarios/${this.$route.params.id}`)
        } catch (err) {
            console.error('Error al cargar usuario:', err)
        } finally {
            this.cargando = false
        }
    },

    methods: {
        async onRegistrado (usuario) {
            this.cargando = true
            try {
                await ApiService.put(`api/panel/usuarios/${usuario.id}`, usuario)
                this.mostrarMensaje = true
                this.mensaje = { texto: 'Usuario actualizado correctamente', color: 'success' }
                setTimeout(() => this.$router.push({ name: 'Usuarios' }), 1000)
            } catch (err) {
                console.error('Error al actualizar usuario:', err)
                const msg = err.response && err.response.data && err.response.data.mensaje
                this.mostrarMensaje = true
                this.mensaje = { texto: msg || 'Error al actualizar usuario', color: 'error' }
            } finally {
                this.cargando = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/EditarUsuario.vue